"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var use_validate_token_exports = {};
__export(use_validate_token_exports, {
  useValidateToken: () => useValidateToken
});
module.exports = __toCommonJS(use_validate_token_exports);
var import_react = require("react");
var import_use_session = require("./use-session");
const useValidateToken = () => {
  const session = (0, import_use_session.useSession)();
  const validateToken = (0, import_react.useCallback)(
    // Args no longer used but kept to maintain compatibility
    // with the previous implementation.
    async (_data, _update) => {
      return session.data;
    },
    []
  );
  return { validateToken };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useValidateToken
});
